var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-banner"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.bannerList),function(li){return _c('div',{key:li.id,staticClass:"swiper-slide"},[_c('img',{ref:"bannerimg",refInFor:true,attrs:{"src":li.img},on:{"click":function($event){return _vm.goLook(li)}}})])}),0),_c('div',{staticClass:"swiper-pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }